var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfiniti(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.533 12.8c-9.03 0-16.346 3.685-16.346 8.224 0 3.675 4.8 6.784 11.418 7.835l4.928-11.734 4.928 11.734c6.624-1.067 11.419-4.16 11.419-7.835 0-4.539-7.318-8.224-16.347-8.224zm7.504 12.347l-7.504-8.688-7.467 8.661c-3.69-1.024-6.133-2.816-6.133-5.024 0-3.493 6.048-6.763 13.59-6.763 7.54 0 13.711 3.28 13.711 6.774 0 2.213-2.464 4.016-6.197 5.04z"
  })));
}
export default SvgInfiniti;